import { Question } from "../../../../../../scripts/gen-question/src/declare/question.model";

export const getQuestionGuide = (
  currentQuestion: Question,
  answerCache: any
): string => {
  if (!currentQuestion) return "";

  if (currentQuestion.code.indexOf("B2212_i") === 0) {
    // 读取 B2210 的答案
    const a = (((answerCache || {})["B2210"] || {}).answer || [])[0] || {};

    const count = a.value || 0;
    if (a.code == '2') {
      return "下面我们想了解贵企业目前尚未还清的最主要一笔贷款情况，“主要一笔” 是指金额最大那笔，若金额最大有两笔，选择时间更靠后（最新）的那笔";
    } else if (count == 1) return "";

    if (count > 1 && count <= 5) {
      const index = currentQuestion.code.replace("B2212_i", "");
      let tip = `目前尚未还清的第 ${index} 笔贷款情况`;
      if (`${index}` == "1") {
        tip = `下面我们想依次了解贵企业目前尚未还清的每一笔贷款的情况。\n${tip}`;
      }
      return tip;
    } else if (count > 5) {
      const index = currentQuestion.code.replace("B2212_i", "");
      let tip = `目前尚未还清的第 ${index} 大笔贷款情况`;
      if (`${index}` == "1") {
        tip = `下面我们想了解贵企业目前尚未还清的主要五笔贷款情况，“主要一笔” 是指金额最大那笔，若金额最大有两笔，选择时间更靠后（最新）的那笔。\n${tip}`;
      }
      return tip;
    }
  }

  if (currentQuestion.code === "B7101") {
    return "下面我们想问一下数字化经营方面的问题。";
  }
  return "";
};
